module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_transportation.aab39c1b.png";